import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function ItemConditionBadge({ condition }: Readonly<{ condition: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  return (
    <Text span fz={14}>
      {condition ? t(`condition.${condition}`, { defaultValue: "-" }) : "-"}
    </Text>
  )
}
